<div class="login-container">
  <!-- Partículas decorativas -->
  <div class="particle" *ngFor="let p of particles" [ngStyle]="{
    'left': p.left,
    'top': p.top,
    'width': p.size,
    'height': p.size,
    'animation-delay': p.delay
  }"></div>

  <!-- Card -->
  <mat-card class="login-card dashboard-card">
    <img mat-card-image src="https://w3miglm.blob.core.windows.net/com/wwwInternals/Login/login_card.webp"
      alt="Recuperar contraseña" class="card-header-image" />

    <mat-card-content class="card-content">
      <mat-card-header>
        <mat-card-title>Recuperar contraseña</mat-card-title>
        <mat-card-subtitle>Para fijar su contraseña, escriba su correo electrónico registrado</mat-card-subtitle>
      </mat-card-header>
      
      
      <mat-form-field appearance="outline" class="full-width-form-field">
        <mat-label>Correo electrónico</mat-label>
        <input matInput formControlName="email" type="email" required>
        <mat-icon matSuffix>email</mat-icon>
        <mat-error >
          Campo obligatorio
        </mat-error>
        <mat-error >
          Ingrese un correo válido
        </mat-error>
      </mat-form-field>

      <!-- Botón y carga -->
      <div class="submit-button">
        <button mat-flat-button type="submit" class="login-button" [disabled]="loading">
          <mat-icon>send</mat-icon> Enviar
        </button>
      </div>


      <mat-progress-bar *ngIf="loading" mode="indeterminate" color="accent"></mat-progress-bar>

      <!-- Mensajes -->
      <mat-card *ngIf="successMessage" class="alert success">{{ successMessage }}</mat-card>
      <mat-card *ngIf="errorMessage" class="alert error">{{ errorMessage }}</mat-card>

      <div class="alternative-login">
        <a (click)="goToLogin()">
          <button mat-raised-button color="accent">
            <mat-icon>arrow_back</mat-icon> Volver al inicio
          </button>
        </a>
      </div>
    </mat-card-content>
  </mat-card>
</div>